export enum WAREHOUSE_AREA_PERMISSIONS {
  WAREHOUSE_AREA_VIEW = 'INVENTORY_WAREHOUSEAREAVIEW',
  WAREHOUSE_AREA_WRITE = 'INVENTORY_WAREHOUSEAREAWRITE',
}
